import React from 'react';
import { _cs, isValidUrl } from '@togglecorp/fujs';
import { Link } from 'react-router-dom';
import ElementFragments from '../ElementFragments/index.js';
import RawButton from '../RawButton/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
}; // FIXME: remove this (only used in stories)

function DropdownMenuItem(props) {
  const {
    className: classNameFromProps,
    icons,
    actions,
    children,
    iconsContainerClassName,
    childrenContainerClassName,
    actionsContainerClassName,
    spacing = 'comfortable',
    href,
    disabled = false
  } = props;

  const className = _cs(styles.dropdownMenuItem, spacingToStyleMap[spacing], classNameFromProps, disabled && styles.disabled);

  const content = /*#__PURE__*/React.createElement(ElementFragments, {
    icons: icons,
    actions: actions,
    iconsContainerClassName: iconsContainerClassName,
    childrenContainerClassName: childrenContainerClassName,
    actionsContainerClassName: actionsContainerClassName
  }, children);

  if (href !== undefined) {
    const isExternalLink = href && typeof href === 'string' && (isValidUrl(href) || href.startsWith('mailto:'));

    if (isExternalLink) {
      return /*#__PURE__*/React.createElement("a", {
        className: className,
        href: href,
        target: "_blank",
        rel: "noreferrer"
      }, content);
    }

    return /*#__PURE__*/React.createElement(Link, {
      className: className,
      to: href
    }, children);
  }

  return /*#__PURE__*/React.createElement(RawButton, {
    className: className // eslint-disable-next-line react/destructuring-assignment
    ,
    name: props.name // eslint-disable-next-line react/destructuring-assignment
    ,
    onClick: props.onClick,
    disabled: disabled
  }, content);
}

var index = genericMemo(DropdownMenuItem);

export { index as default };
//# sourceMappingURL=index.js.map
